import {
  IdentificationTypeIdEnum,
  UserDetailsAttributes,
} from "../attributes/user-attributes";
import { parseDate } from "../common/Hooks";

class UserDetail {
  id: number;
  telephone: string;
  activity_time_preference: string;
  identification_type_id: IdentificationTypeIdEnum;
  last_name: string;
  first_name: string;
  email: string;
  data_of_birth: Date | null;
  birth_place: string | null;
  secondary_telephone: string | null;
  address: string | null;
  city: string | null;

  constructor(
    id: number,
    telephone: string,
    activity_time_preference: string,
    identification_type_id: IdentificationTypeIdEnum,
    last_name: string,
    first_name: string,
    email: string,
    data_of_birth: Date | null,
    birth_place: string | null,
    secondary_telephone: string | null,
    address: string | null,
    city: string | null
  ) {
    this.id = id;
    this.telephone = telephone;
    this.activity_time_preference = activity_time_preference;
    this.identification_type_id = identification_type_id;
    this.last_name = last_name;
    this.first_name = first_name;
    this.email = email;
    this.data_of_birth = data_of_birth;
    this.birth_place = birth_place;
    this.secondary_telephone = secondary_telephone;
    this.address = address;
    this.city = city;
  }

  static fromJson(
    json: UserDetailsAttributes | null | undefined
  ): UserDetail | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new UserDetail(
      json.id,
      json.telephone,
      json.activity_time_preference,
      json.identification_type_id,
      json.last_name,
      json.first_name,
      json.email,
      parseDate(json.data_of_birth),
      json.birth_place,
      json.secondary_telephone,
      json.address,
      json.city
    );
  }
}

export default UserDetail;
